var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.establishment.logo === '')?_c('div',{staticClass:"myicon"},[_c('i',{staticClass:"fa fa-hotel"})]):_c('div',{staticClass:"logo card-img sh-6 sw-6",style:(_vm.logo_style)})])}
var staticRenderFns = []

export { render, staticRenderFns }